/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { withMyTheme } from "../theme/theme";
import { Typography, Container, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { mobileCss } from "../util/isMobile";

const PageContainerStyle = withMyTheme((theme) => css`
  min-height: 100vh;
  padding: 5rem 2rem;
  background-color: ${theme.palette.background.default};
  
  ${mobileCss(`
    padding: 3rem 1rem;
  `)}
`);

const TitleStyle = withMyTheme((theme) => css`
  font-family: 'Great Vibes', serif;
  font-size: 3rem;
  color: ${theme.palette.primary.main};
  text-align: center;
  margin-bottom: 2rem;
  
  ${mobileCss(`
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  `)}
`);

const ContentStyle = withMyTheme((theme) => css`
  font-family: 'Cormorant', serif;
  font-size: 1.2rem;
  color: ${theme.palette.text.primary};
  line-height: 1.8;
  margin-bottom: 2rem;
  
  h2 {
    font-family: 'Cormorant', serif;
    font-size: 1.8rem;
    color: ${theme.palette.primary.main};
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  
  p {
    margin-bottom: 1.5rem;
  }
  
  ${mobileCss(`
    font-size: 1.1rem;
    line-height: 1.6;
  `)}
`);

const BackButtonStyle = withMyTheme((theme) => css`
  margin-bottom: 2rem;
  color: ${theme.palette.primary.main};
  
  &:hover {
    background-color: rgba(212, 163, 115, 0.1);
  }
`);

export const PrivacyPolicy = () => {
  const navigate = useNavigate();
  
  return (
    <div css={PageContainerStyle}>
      <Container maxWidth="md">
        <Button 
          startIcon={<ArrowBackIcon />} 
          onClick={() => navigate('/')} 
          css={BackButtonStyle}
        >
          Powrót do strony głównej
        </Button>
        
        <Typography variant="h1" css={TitleStyle}>
          Polityka Prywatności
        </Typography>
        
        <div css={ContentStyle}>
          <h2>1. Informacje ogólne</h2>
          <p>
            Niniejsza Polityka Prywatności określa zasady przetwarzania i ochrony danych osobowych przekazanych przez Użytkowników w związku z korzystaniem z naszych usług tworzenia stron ślubnych.
          </p>
          
          <h2>2. Administrator danych</h2>
          <p>
            Administratorem danych osobowych jest Weddie Site, z siedzibą w Polsce.
          </p>
          
          <h2>3. Cel i zakres zbierania danych</h2>
          <p>
            Przetwarzamy dane osobowe Użytkowników w celu:
          </p>
          <ul>
            <li>Realizacji usługi tworzenia i utrzymania strony ślubnej</li>
            <li>Kontaktu z klientem w sprawach związanych z realizacją usługi</li>
            <li>Rozpatrzenia ewentualnych reklamacji</li>
            <li>Wystawienia dokumentów księgowych</li>
          </ul>
          
          <h2>4. Rodzaj przetwarzanych danych</h2>
          <p>
            Przetwarzamy następujące dane osobowe:
          </p>
          <ul>
            <li>Imię i nazwisko</li>
            <li>Adres e-mail</li>
            <li>Numer telefonu</li>
            <li>Informacje dobrowolnie przekazane przez klienta w celu stworzenia strony ślubnej</li>
          </ul>
          
          <h2>5. Okres przechowywania danych</h2>
          <p>
            Dane osobowe przechowywane są przez okres niezbędny do realizacji usługi oraz przez okres wynikający z przepisów prawa, w szczególności przepisów podatkowych i rachunkowych.
          </p>
          
          <h2>6. Prawa użytkowników</h2>
          <p>
            Użytkownikom przysługuje prawo do:
          </p>
          <ul>
            <li>Dostępu do swoich danych</li>
            <li>Sprostowania (poprawiania) swoich danych</li>
            <li>Usunięcia danych</li>
            <li>Ograniczenia przetwarzania danych</li>
            <li>Przenoszenia danych</li>
            <li>Wniesienia sprzeciwu wobec przetwarzania danych</li>
            <li>Wniesienia skargi do organu nadzorczego</li>
          </ul>
          
          <h2>7. Bezpieczeństwo danych</h2>
          <p>
            Stosujemy odpowiednie środki techniczne i organizacyjne, aby zapewnić bezpieczeństwo przetwarzanych danych osobowych.
          </p>
          
          <h2>8. Kontakt</h2>
          <p>
            W sprawach związanych z przetwarzaniem danych osobowych można kontaktować się z nami pod adresem email: kontakt@weddie.site
          </p>
          
          <h2>9. Zmiany polityki prywatności</h2>
          <p>
            Zastrzegamy sobie prawo do zmiany niniejszej Polityki Prywatności poprzez opublikowanie nowej wersji na naszej stronie internetowej.
          </p>
        </div>
      </Container>
    </div>
  );
};
